import { render } from "./StartersIndex.vue?vue&type=template&id=50464326&scoped=true"
import script from "./StartersIndex.vue?vue&type=script&lang=js"
export * from "./StartersIndex.vue?vue&type=script&lang=js"

import "./StartersIndex.vue?vue&type=style&index=0&id=50464326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50464326"]])

export default __exports__